import { render, staticRenderFns } from "./bolt_work_hour.vue?vue&type=template&id=36ba1eb2&scoped=true&"
import script from "./bolt_work_hour.vue?vue&type=script&lang=js&"
export * from "./bolt_work_hour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba1eb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ba1eb2')) {
      api.createRecord('36ba1eb2', component.options)
    } else {
      api.reload('36ba1eb2', component.options)
    }
    module.hot.accept("./bolt_work_hour.vue?vue&type=template&id=36ba1eb2&scoped=true&", function () {
      api.rerender('36ba1eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt/location/tabs/bolt_work_hour.vue"
export default component.exports